import {
  CheckIcon,
  GKButton,
  GKEditor,
  GKModal,
  GKTextField,
  Grid2,
  InfoItalicIcon,
  Typography,
} from "components";
import { useMutation } from "hooks/useQueries";
import { FaqListInterface } from "interfaces/WebsiteInterface";
import { Controller, useFormContext } from "react-hook-form";
import axiosInstance from "utils/axiosInstance";
import { refetchQuery } from "utils/helpers";

const FaqModal = ({
  open,
  setOpen,
  selectedQuestion,
}: {
  open: boolean;
  selectedQuestion: number;
  setOpen: (d: boolean) => void;
}) => {
  const form = useFormContext<FaqListInterface>();

  const { mutate, isLoading } = useMutation({
    mutationFn: (data: FaqListInterface) =>
      axiosInstance.patch(`/faqs/update-faqs/`, data),
    onSuccess: () => {
      refetchQuery("GET_ALL_ALL_FAQS");
      form.setValue("isEditing", false);
    },
  });

  const handleSubmit = (values: FaqListInterface) => {
    mutate(values);
  };

  return (
    <GKModal
      onCloseModal={() => {
        setOpen(false);
        form.reset();
      }}
      setOpen={setOpen}
      open={open}
      modalTitle={form.watch("isEditing") ? "Update FAQ" : "Add New FAQ"}
      footer={
        <GKButton
          loading={isLoading}
          variant="contained"
          startIcon={<CheckIcon />}
          onClick={form.handleSubmit((values) => {
            handleSubmit(values);
          })}
        >
          {form.watch("isEditing") ? "Save Changes" : "Add FAQ"}
        </GKButton>
      }
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
          <InfoItalicIcon color="var(--neutral-500)" />
          <Typography fontSize={12} color="var(--neutral-500)">
            {form.watch("isEditing")
              ? "Update the question or answer below. Changes will reflect immediately on your website after saving."
              : "Write like you're answering a client directly. Keep it short, clear, & helpful."}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            rules={{
              required: {
                value: true,
                message: "Please enter question",
              },
            }}
            name={`questionsAnswers.${selectedQuestion}.question`}
            render={({ field, fieldState: { error } }) => {
              return (
                <GKTextField
                  {...field}
                  inputLabel="Question"
                  fullWidth
                  error={!!error}
                />
              );
            }}
          />
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name={`questionsAnswers.${selectedQuestion}.answer`}
            rules={{
              required: {
                value: true,
                message: "Please enter question",
              },
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <GKEditor
                  {...field}
                  inputLabel="answer"
                  requiredField
                  error={!!error}
                  helperText={error?.message}
                  toolbar={[
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "|",
                    "link",
                    "|",
                    "bulletedList",
                    "numberedList",
                  ]}
                />
              );
            }}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default FaqModal;
